import styled from "styled-components";

export const Styles = styled.span`
  display: inline-flex;
  flex-direction: column;
  margin-right: 0.125rem;
  float: left;
  line-height: 0.625rem;
  font-size: 0.625rem;
`;
